const RefreshGrid = (store, tableKey, params, type, isBtnSearch) => {
  // console.log(
  //   "RefreshGrid:",
  //   "store:",
  //   store,
  //   "tableKey:",
  //   tableKey,
  //   "params:",
  //   params,
  //   "type:",
  //   type,
  //   "isBtnSearch:",
  //   isBtnSearch,
  //   "---",
  //   store.getState(),
  //   store.getState().gridsInfo,
  //   store.getState().gridsInfo.context,
  //   store.getState().gridsInfo.context[tableKey],
  // );
  // params:自定义的传过来的param,
  // 定义param:对应tableKey的查询params
  const [context, param] = [
    store.getState().gridsInfo.context[tableKey],
    store.getState().gridsInfo.context[tableKey].params,
  ];

  if (type) {
    return store.getState().gridsInfo.fetchDataHandler.bind(context)(
      !1,
      Object.assign(param, params),
    );
  } else {
    return store.getState().gridsInfo.fetchDataHandler.bind(context)(!0, {
      ...param,
      isBtnSearch: isBtnSearch,
      ...params,
    });
  }
};

export default RefreshGrid;



// WEBPACK FOOTER //
// ./src/AntD/utils/refreshGrid.js